import { updater } from "../../utils/updater.js";

/**
 * Popupcontextmenu API factory.
 *
 */
export function popupContextMenuFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const setPosition = (e, containerElem, fileId) => {
    updateState((draft) => {
      draft.position = {
        top: e.clientY,
        left: e.clientX,
      };
      draft.isOpen = true;
      draft.fileId = fileId;
    });
  };

  const setContent = (content) =>
    updateState((draft) => {
      draft.content = content;
    });

  const setOpenCondition = (bool) =>
    updateState((draft) => {
      draft.isOpen = bool;
    });

  const closePopup = () => {
    updateState((draft) => {
      draft.content = null;
      draft.isOpen = false;
      draft.position = {};
    });
  };

  const getPosition = () => state.position;
  const getContent = () => state.content;
  const getFileId = () => state.fileId;
  const getOpenCondition = () => state.isOpen;

  return {
    setPosition,
    setContent,
    setOpenCondition,
    getFileId,
    getPosition,
    getOpenCondition,
    getContent,
    closePopup,
  };
}

export default popupContextMenuFactory;
